var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@lucidlink/uicore';
import { LogConsole, LogControls, LogLevels } from './components';
export const Logging = ({ clearLogs, copyLogsToClipboard, downloadLogs, filespaceClient, logs, }) => {
    const isDisabled = filespaceClient === undefined;
    return (_jsxs(Box, { gap: "m", orientation: "vertical", children: [_jsx(LogLevels, { disabled: isDisabled, filespaceClient: filespaceClient }), _jsx(LogControls, { clearLogs: clearLogs, copyLogsToClipboard: copyLogsToClipboard, disabled: isDisabled, downloadLogs: downloadLogs }), _jsx(LogConsole, { disabled: isDisabled, logs: logs })] }));
};
_react_refresh_temp_1 = Logging;
$RefreshReg$(_react_refresh_temp_1, "Logging");
